import L from 'leaflet';
import marker2x from 'leaflet/dist/images/marker-icon-2x.png';
import marker1x from 'leaflet/dist/images/marker-icon.png';
import shadow from 'leaflet/dist/images/marker-shadow.png';

// Leaflet's default marker image URLs can be missing unless we wire them explicitly.
delete (L.Icon.Default.prototype as any)._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: marker2x,
  iconUrl: marker1x,
  shadowUrl: shadow,
});

// GUARD: Prevent markercluster _animationEnd race condition.
// After clearLayers(), marker.__parent becomes undefined. A queued CSS
// animationend fires showMarker → hasLayer(undefined) → stamp(undefined) → crash.
// Patching stamp() at the source so it returns -1 for nullish inputs.
const origStamp = L.Util.stamp;
(L.Util as any).stamp = function (obj: any) {
  if (obj == null) return -1;
  return origStamp.call(this, obj);
};
